/**
 * useLogin.js
 * Business logic extracted from LoginPanel.js's handleSubmit. The
 * component (LoginForm.jsx) now only renders fields and calls
 * `handleSubmit`; it doesn't know about validation, the API, or the
 * session service.
 */

import { useState } from "react";
import { useAsync } from "../../../shared/hooks/useAsync";
import { useFormFields } from "../../../shared/hooks/useFormFields";
import { authenticationApi } from "../api/authentication.api";
import { isValid, validateFields } from "../validation/authentication.validation";
import { useSession } from "./useSession";

export function useLogin({ onOtpRequired, onSuccess }) {
    const { fields, set } = useFormFields({ email: "", password: "" });
    const [fieldErrors, setFieldErrors] = useState({});
    const { run, loading, error } = useAsync();
    const { establishSession } = useSession();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateFields(fields);
        setFieldErrors(errors);
        if (!isValid(errors)) return;

        const data = await run(() => authenticationApi.login(fields.email, fields.password));
        if (!data) return;

        if (data.otpRequired) {
            onOtpRequired?.();
            return;
        }

        if (data.token) {
            establishSession(data.token);
        }
        onSuccess?.();
    };

    return { fields, set, fieldErrors, loading, error, handleSubmit };
}
